export default __webpack_public_path__ + "static/media/vaave.9825fd08.png";